import HomeIcon from "@mui/icons-material/Home";
import PieChartIcon from "@mui/icons-material/PieChart";
import LayersIcon from "@mui/icons-material/Layers";
import BarChartIcon from "@mui/icons-material/BarChart";
import PersonIcon from "@mui/icons-material/Person";
import type { SvgIconComponent } from "@mui/icons-material";

export const DRAWER_WIDTH = 256;

export interface NavItem {
  label: string;
  i18nKey: string;
  path: string;
  icon: SvgIconComponent;
  requiresAuth: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Home",
    i18nKey: "nav.home",
    path: "/",
    icon: HomeIcon,
    requiresAuth: false,
  },
  {
    label: "Tracker",
    i18nKey: "nav.tracker",
    path: "/tracker",
    icon: PieChartIcon,
    requiresAuth: true,
  },
  {
    label: "Manage",
    i18nKey: "nav.manage",
    path: "/manage",
    icon: LayersIcon,
    requiresAuth: true,
  },
  {
    label: "Reports",
    i18nKey: "nav.reports",
    path: "/reports",
    icon: BarChartIcon,
    requiresAuth: true,
  },
  {
    label: "Account",
    i18nKey: "nav.account",
    path: "/account",
    icon: PersonIcon,
    requiresAuth: false,
  },
];
